import React, { useState, useRef } from "react";
import { base_url } from "../../Constant";
import "bootstrap/dist/css/bootstrap.min.css";

const BloodDonationForm = () => {
  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const westBengalDistricts = [
    "Alipurduar",
    "Bankura",
    "Birbhum",
    "Cooch Behar",
    "Darjeeling",
    "Dinajpur",
    "East Bardhaman",
    "East Medinipur",
    "Hooghly",
    "Howrah",
    "Jalpaiguri",
    "Jhargram",
    "Kalimpong",
    "Kanksa",
    "Kolkata",
    "Malda",
    "Medinipur",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Paschim Bardhaman",
    "Paschim Medinipur",
    "Purba Bardhaman",
    "Purnia",
    "South 24 Parganas",
    "Uttar Dinajpur",
    "West Midnapore",
  ];

  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    gender: "",
    bloodGroup: "",
    contactNumber: "",
    email: "",
    address: "",
    city: "",
    state: "West Bengal",
    stateOther: "",
    district: "",
    districtOther: "",
    lastDonationDate: "",
    medicalConditions: "",
    dbd:"",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // Loading state
  const firstErrorRef = useRef(null); // Ref for the first error field

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    const today = new Date();
    const dob = new Date(formData.dob);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    if (age < 18) {
      newErrors.dob = "You must be at least 18 years old.";
    }

    if (!/^\d{10}$/.test(formData.contactNumber)) {
      newErrors.contactNumber = "Contact number must be a 10-digit number.";
    }

    if (!formData.fullName) {
      newErrors.fullName = "Full name is required.";
    }

    if (!formData.gender) {
      newErrors.gender = "Gender is required.";
    }

    if (!formData.bloodGroup) {
      newErrors.bloodGroup = "Blood group is required.";
    }

    if (!formData.email) {
      newErrors.email = "Email is required.";
    }

    if (!formData.address) {
      newErrors.address = "Address is required.";
    }

    if (!formData.city) {
      newErrors.city = "City is required.";
    }

    if (!formData.state) {
      newErrors.state = "State is required.";
    }

    if (formData.state === "Other" && !formData.stateOther) {
      newErrors.stateOther = "Please enter your state name.";
    }

    if (!formData.district) {
      newErrors.district = "District is required.";
    }

    if (formData.district === "Other" && !formData.districtOther) {
      newErrors.districtOther = "Please enter your district name.";
    }

    if (!formData.consent) {
      newErrors.consent = "You must consent to donate blood.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      // Scroll to the first error field
      if (firstErrorRef.current) {
        firstErrorRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    setLoading(true); // Show loader
    const payload = {
      ...formData,
    };

    try {
      const response = await fetch(
        `${base_url}/dbd`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("🩸 Thank you for registering! You're a real-life hero.");
      } else {
        alert(`❌ Submission failed: ${result.error || "Unknown error"}`);
        console.error("API error:", result);
      }
    } catch (error) {
      alert("🚨 Network error. Please try again later.");
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <div className="container mt-5 position-relative">
      {/* Watermark */}
      <img
        src="/assets/img/mlogo/mlogo.png"
        alt="Watermark"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          opacity: 0.07,
          zIndex: 0,
          width: "70%",
        }}
      />

      <div className="position-relative" style={{ zIndex: 1 }}>
        <div className="text-center mb-4">
          <h2 className="fw-bold text-danger">
            🩸 Blood Donation Registration
          </h2>
          <p className="text-muted fst-italic">
            “The gift of blood is the gift of life.” ❤️
          </p>
        </div>

        <div className="card shadow-lg p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Full Name */}
              <div
                className="col-md-6 mb-3"
                ref={errors.fullName ? firstErrorRef : null}
              >
                <label className="form-label">👤 Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
                {errors.fullName && (
                  <div className="text-danger">{errors.fullName}</div>
                )}
              </div>

              {/* Date of Birth */}
              <div
                className="col-md-6 mb-3"
                ref={errors.dob ? firstErrorRef : null}
              >
                <label className="form-label">🎂 Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  required
                />
                {errors.dob && <div className="text-danger">{errors.dob}</div>}
              </div>

              {/* Gender */}
              <div
                className="col-md-6 mb-3"
                ref={errors.gender ? firstErrorRef : null}
              >
                <label className="form-label">🚻 Gender</label>
                <select
                  className="form-select"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && (
                  <div className="text-danger">{errors.gender}</div>
                )}
              </div>

              {/* Email */}
              <div
                className="col-md-6 mb-3"
                ref={errors.email ? firstErrorRef : null}
              >
                <label className="form-label">🎂 Email</label>
                <input
                  type="text"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && (
                  <div className="text-danger">{errors.email}</div>
                )}
              </div>

              {/* Contact Number */}
              <div
                className="col-md-6 mb-3"
                ref={errors.contactNumber ? firstErrorRef : null}
              >
                <label className="form-label">🎂 Contact Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  required
                />
                {errors.contactNumber && (
                  <div className="text-danger">{errors.contactNumber}</div>
                )}
              </div>

              {/* Blood Group */}
              <div
                className="col-md-6 mb-3"
                ref={errors.bloodGroup ? firstErrorRef : null}
              >
                <label className="form-label">🧬 Blood Group</label>
                <select
                  className="form-select"
                  name="bloodGroup"
                  value={formData.bloodGroup}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A−">A−</option>
                  <option value="B+">B+</option>
                  <option value="B−">B−</option>
                  <option value="AB+">AB+</option>
                  <option value="AB−">AB−</option>
                  <option value="O+">O+</option>
                  <option value="O−">O−</option>
                  <option value="other">Other</option>
                </select>
                {errors.bloodGroup && (
                  <div className="text-danger">{errors.bloodGroup}</div>
                )}
              </div>
              {/* {Address } */}
              <div
                className="col-md-6 mb-3"
                ref={errors.city ? firstErrorRef : null}
              >
                <label className="form-label">📍 Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
                {errors.address && (
                  <div className="text-danger">{errors.address}</div>
                )}
              </div>
              {/* { City} */}
              <div
                className="col-md-6 mb-3"
                ref={errors.city ? firstErrorRef : null}
              >
                <label className="form-label">🏙️City</label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
                {errors.city && (
                  <div className="text-danger">{errors.city}</div>
                )}
              </div>

              {/* State */}
              <div
                className="col-md-6 mb-3"
                ref={errors.state ? firstErrorRef : null}
              >
                <label className="form-label">🌍 State</label>
                <select
                  className="form-select"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select State</option>
                  {indianStates.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                  <option value="Other">Other</option>
                </select>
                {errors.state && (
                  <div className="text-danger">{errors.state}</div>
                )}
              </div>

              {/* State Other - Only show if "Other" is selected */}
              {formData.state === "Other" && (
                <div
                  className="col-md-6 mb-3"
                  ref={errors.stateOther ? firstErrorRef : null}
                >
                  <label className="form-label">🌍 Enter State Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="stateOther"
                    value={formData.stateOther}
                    onChange={handleChange}
                    placeholder="Enter your state name"
                    required
                  />
                  {errors.stateOther && (
                    <div className="text-danger">{errors.stateOther}</div>
                  )}
                </div>
              )}

              {/* District */}
              <div
                className="col-md-6 mb-3"
                ref={errors.district ? firstErrorRef : null}
              >
                <label className="form-label">📍 District</label>
                <select
                  className="form-select"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select District</option>
                  {westBengalDistricts.map((dist) => (
                    <option key={dist} value={dist}>
                      {dist}
                    </option>
                  ))}
                  <option value="Other">Other</option>
                </select>
                {errors.district && (
                  <div className="text-danger">{errors.district}</div>
                )}
              </div>

              {/* District Other - Only show if "Other" is selected */}
              {formData.district === "Other" && (
                <div
                  className="col-md-6 mb-3"
                  ref={errors.districtOther ? firstErrorRef : null}
                >
                  <label className="form-label">📍 Enter District Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="districtOther"
                    value={formData.districtOther}
                    onChange={handleChange}
                    placeholder="Enter your district name"
                    required
                  />
                  {errors.districtOther && (
                    <div className="text-danger">{errors.districtOther}</div>
                  )}
                </div>
              )}

              {/* { lastDonationDate} */}
              <div
                className="col-md-6 mb-3"
                ref={errors.lastDonationDate ? firstErrorRef : null}
              >
                <label className="form-label">Last Donation Date</label>
                <input
                  type="Date"
                  className="form-control"
                  name="lastDonationDate"
                  value={formData.lastDonationDate}
                  onChange={handleChange}
                  required
                />
                {errors.lastDonationDate && (
                  <div className="text-danger">{errors.lastDonationDate}</div>
                )}
              </div>
              {/* { Medical Conditions} */}
              <div
                className="col-md-6 mb-3"
                ref={errors.medicalConditions ? firstErrorRef : null}
              >
                <label className="form-label">Medical Conditions</label>
                <input
                  type="text"
                  className="form-control"
                  name="medicalConditions"
                  value={formData.medicalConditions}
                  onChange={handleChange}
                  required
                />
                {errors.medicalConditions && (
                  <div className="text-danger">{errors.medicalConditions}</div>
                )}
              </div>

              {/* Blood Donation Type */}
              <div
                className="col-md-6 mb-3"
                ref={errors.dbd ? firstErrorRef : null}
              >
                <label className="form-label">🩸 Blood Donation Type</label>
                <select
                  className="form-select"
                  name="dbd"
                  value={formData.dbd}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Direct Blood Donate">
                    Direct Blood Donate
                  </option>
                  <option value="Blood Donation Camp">
                    Blood Donation Camp
                  </option>
                  <option value="Both">Both</option>
                </select>
                {errors.dbd && <div className="text-danger">{errors.dbd}</div>}
              </div>

              {/* Consent */}
              <div
                className="col-12 mb-3"
                ref={errors.consent ? firstErrorRef : null}
              >
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="consent"
                    id="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                    required
                  />
                  <label className="form-check-label" htmlFor="consent">
                    ✅ I consent to donate blood and confirm the information is
                    accurate.
                  </label>
                </div>
                {errors.consent && (
                  <div className="text-danger">{errors.consent}</div>
                )}
              </div>
            </div>

            <div className="text-center">
              <button type="submit" className="btn btn-danger px-5 py-2">
                🚑 Submit
              </button>
            </div>
          </form>
        </div>

        {/* Loader */}
        {loading && (
          <div className="loader-overlay">
            <img
              src="/assets/img/mlogo/mlogo.png"
              alt="Loading..."
              className="loader"
            />
            <div className="loader-text">Submitting...</div>
          </div>
        )}

        <div className="mt-4 text-center text-danger fw-bold">
          💖 Every drop counts. Be the reason someone smiles today!
        </div>
      </div>

      <style jsx>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .loader {
          width: 100px; /* Adjust size as needed */
          height: auto;
        }
        .loader-text {
          margin-top: 20px;
          font-size: 1.5rem;
          color: #dc3545; /* Bootstrap danger color */
        }
      `}</style>
    </div>
  );
};

export default BloodDonationForm;
